import { Fragment } from 'react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export interface Detail {
  key: string;
  value: string;
  isHeader?: boolean;
}

export interface RenderDetailsProps {
  details: Detail[];
}

export const RenderDetails: React.FC<RenderDetailsProps> = ({ details }) => (
  <>
    {details.map((detail) => (
      <Fragment key={detail.key}>
        <TextBodyMedium bold={detail.isHeader}>{detail.key}</TextBodyMedium>
        <TextBodyMedium>{detail.isHeader ? '' : detail.value || 'None'}</TextBodyMedium>
      </Fragment>
    ))}
  </>
);
